export default "__VITE_ASSET__B71sSnKL__"